import { httpRequest } from "../../utils/HttpRequest";
import {
    IAccountFields,
    IAccountDetail,
    IAccountAdjustApproval,
    IAccountAdjustSubmit,
    IAccountOne,
    IAccountSearch,
    IAccountAdjustFields,
    IAccountAdjustSearch,
    IAccountAdjustDetail,
    IAccountTransferFields,
    IAccountTransferDetail,
    IAccountTransferSearch,
    IAccountWriteoffFields,
    IAccountWriteoffDetail,
    IAccountWriteoffSearch,
    IAccountRechargeFields,
    IAccountRechargeDetail,
    IAccountRechargeSearch,
    IAccountLogSearch,
    IAccountLogDetail,
    ICustomerAccountSummary,
    IAccountSummary,
    ISupplierAccountSummary,
    IFMSInitAccountForm,
    IAccountTransactFields,
    IAccountTransactSearch,
    IAccountTransactDetail,
    IAllotAccountFields,
    IAllotAccountSearch,
    IAllotAccountDetail,
    IAccountRechargeApproval,
    IRechargeTotalAmount,
    IAllotAccountWriteoffSearch,
    IAllotAccountWriteoffDetail,
    IAllotAccountWriteoffFields,
    IAllotAccountTransactionSearch,
    IAllotAccountTransactionDetail,
    IAllotAccountSummary,
    IAllotSummaryAmount,
    IRechangeMsgFields,
    IRechangeMsgSearchParam,
    IRechangeMsgSearch,
    IAccountReceivableSearchParam,
    IAccountReceivableDetail,
    IAccountReceivableSearch,
    ICustomerMergePageSearch,
    ICustomerMergeItem,
    ICustomerMergeBindData,
    IMergerCustermerInfo
} from "./AccountTypes";
import { IPage, IRet } from "../../types/FmsTypes";
import { IMdCustomerSearch } from "../base/customer/customerService";
import { IMdSupplierSearch } from "../base/supplier/supplierService";
import { Key } from "react";
import { CreditFlagEnum } from "../../types/FmsEnums";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import { IMdBeFields } from "../base/be/beService";

export interface IAcctUnitDetail {
    id: string,
    address: string,
    bentity: string,
    bentityList: IMdBeFields[],
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

export const creditFlagDs = () => {
    return [{
        label: '记账',
        value: CreditFlagEnum.CREDIT.valueOf()
    }, {
        label: '现结',
        value: CreditFlagEnum.NON_CREDIT.valueOf()
    }, {
        label: '结转',
        value: CreditFlagEnum.BALANCE.valueOf()
    }
    ]
}


class AccountService {
    //
    async customerSummaryPage(searchVo: IMdCustomerSearch) {
        const apiUrl = "/account/summary/customer/page";
        return await httpRequest
            .post<IPage<ICustomerAccountSummary>>(apiUrl, searchVo);
    }

    //
    async customerSummaryOne(code: string | Key, shopCode: string) {
        const apiUrl = `/accountShop/summary/customer/one/${code}/${shopCode}`;
        return await httpRequest
            .post<ICustomerAccountSummary>(apiUrl);
    }

    async customerSummaryAll(param: { partnerCodes: string[], shopCode: string }) {
        const apiUrl = `/accountShop/summary/customer/all`;
        return await httpRequest
            .post<ICustomerAccountSummary[]>(apiUrl, param);
    }

    //
    async customerSummary(searchVo: IMdCustomerSearch) {
        const apiUrl = "/account/summary/customer";
        return await httpRequest
            .post<IAccountSummary>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //
    async supplierSummaryPage(searchVo: IMdSupplierSearch) {
        const apiUrl = "/account/summary/supplier/page";
        return await httpRequest
            .post<IPage<ISupplierAccountSummary>>(apiUrl, searchVo);
    }

    //
    async supplierSummaryOne(code: string, shopCode: string) {
        const apiUrl = `/accountShop/summary/supplier/one/${code}/${shopCode}`;
        return await httpRequest
            .post<ISupplierAccountSummary>(apiUrl);

    }

    //
    async supplierSummary(searchVo: IMdSupplierSearch) {
        const apiUrl = "/account/summary/supplier";
        return await httpRequest
            .post<IAccountSummary>(apiUrl, searchVo);
    }

    //开户
    async open(param: IAccountFields) {
        const apiUrl = "/account/open";
        return await httpRequest
            .post<IAccountDetail>(apiUrl, param);
    }
    //充值记录导出
    export(param: IAccountRechargeSearch) {
        const apiUrl = "account/recharge/export";
        return httpRequest.postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }
    //充值记录导出
    logExport(param: IAccountRechargeSearch) {
        const apiUrl = "account/adjust/export";
        return httpRequest.postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }
    //禁用账户
    async disable(param: IAccountOne) {
        const apiUrl = "/account/disable";
        return httpRequest
            .post<boolean>(apiUrl, param)
    }

    //启用账户
    async enable(param: IAccountOne) {
        const apiUrl = "/account/enable";
        return httpRequest
            .post<boolean>(apiUrl, param)
    }

    //账户查询
    async find(param: IAccountFields) {
        const apiUrl = "/account/find";
        return await httpRequest
            .post<IAccountDetail[]>(apiUrl, param)
    }

    //账户查询(分页)
    async page(param: IAccountSearch) {
        const apiUrl = "/account/page";
        return await httpRequest
            .post<IPage<IAccountDetail>>(apiUrl, param)
    }

    //账户查询(单条)
    async one(code: string) {
        const apiUrl = "/account/one/" + code;
        return await httpRequest
            .post<IAccountDetail>(apiUrl);
    }

    //调额
    async adjust(param: IAccountAdjustFields) {
        const apiUrl = "/account/adjust";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    //月结账户调额
    async adjustMonth(param: IAccountAdjustFields) {
        const apiUrl = "/contract/insert";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    //调额提交
    async adjustSubmit(param: IAccountAdjustSubmit) {
        const apiUrl = "/account/adjust/submit";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    //调额审核
    async adjustApproval(param: IAccountAdjustApproval) {
        const apiUrl = "/account/adjust/approval";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    //调额记录查询(分页)
    async adjustPage(param: IAccountAdjustSearch) {
        const apiUrl = "/account/adjust/page";
        return await httpRequest
            .post<IPage<IAccountAdjustDetail>>(apiUrl, param);
    }

    //调额
    async transact(param: IAccountTransactFields) {
        const apiUrl = "/account/transact";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    // //调额提交
    // async transactSubmit(param: IAccountTransactSubmit) {
    //     const apiUrl = "/account/transact/submit";
    //     return await httpRequest
    //         .post<boolean>(apiUrl, param);
    // }

    // //调额审核
    // async transactApproval(param: IAccountTransactApproval) {
    //     const apiUrl = "/account/transact/approval";
    //     return await httpRequest
    //         .post<boolean>(apiUrl, param);
    // }

    //调额记录查询(分页)
    async transactPage(param: IAccountTransactSearch) {
        const apiUrl = "/account/transact/page";
        return await httpRequest
            .post<IPage<IAccountTransactDetail>>(apiUrl, param);
    }

    //转账
    async transfer(param: IAccountTransferFields) {
        const apiUrl = "/account/transfer";
        return await httpRequest
            .post<IAccountTransferDetail>(apiUrl, param);
    }

    //转账记录查询(分页)
    async transferPage(param: IAccountTransferSearch) {
        const apiUrl = "/account/transfer/page";
        return await httpRequest
            .post<IPage<IAccountTransferDetail>>(apiUrl, param);
    }

    //核销
    async writeoff(param: IAccountWriteoffFields) {
        const apiUrl = "/account/writeoff";
        return await httpRequest
            .post<IAccountWriteoffDetail>(apiUrl, param, { timeout: 300000 });
    }

    //核销总额
    async writeoffTotalAmount(param: IAccountWriteoffSearch) {
        const apiUrl = "/account/writeoff/writeoffTotalAmount";
        return await httpRequest
            .post<number>(apiUrl, param);
    }
    // 核销记录查询(分页)
    async writeoffPage(param: IAccountWriteoffSearch) {
        const apiUrl = "/account/writeoff/page";
        return await httpRequest
            .post<IPage<IAccountTransferDetail>>(apiUrl, param);
    }

    //充值
    async recharge(param: IAccountRechargeFields) {
        const apiUrl = "/account/recharge";
        return await httpRequest
            .post<IAccountRechargeDetail>(apiUrl, param);
    }

    //充值总额
    async rechargeTotalAmount(param: IAccountRechargeSearch) {
        const apiUrl = "/account/recharge/rechargeTotalAmount";
        return await httpRequest
            .post<number>(apiUrl, param);
    }

    //充值记录查询(分页)
    async rechargePage(param: IAccountRechargeSearch) {
        const apiUrl = "/account/recharge/page";
        return await httpRequest
            .post<IPage<IAccountRechargeDetail>>(apiUrl, param);
    }
    //充值记录查询(分页)
    async adjustAmountPage(param: IAccountRechargeSearch) {
        const apiUrl = "/account/adjust/page";
        return await httpRequest
            .post<IPage<IAccountRechargeDetail>>(apiUrl, param);
    }
    //充值审批
    async rechargeApproval(param: IAccountRechargeApproval) {
        const apiUrl = "/account/recharge/approval";
        return await httpRequest
            .post<boolean>(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }


    //账户日志查询(分页)
    async logPage(param: IAccountLogSearch) {
        const apiUrl = "/account/log/page";
        return await httpRequest
            .post<IPage<IAccountLogDetail>>(apiUrl, param);
    }

    //账户初始化
    async initAccount(param: IFMSInitAccountForm) {
        const apiUrl = "/account/summary/customer/customerAccount";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    /** 调拨 */

    // 开户
    async allotOpen(param: IAllotAccountFields) {
        const apiUrl = "/allotAccount/open";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    // 根据门店编码查询调拨单位详情
    async allotFindOne(code: string) {
        const apiUrl = `/accountUnit/find/one/${code}`;
        return await httpRequest
            .post<IAcctUnitDetail>(apiUrl);

    }

    // 分页查询账户
    async allotPage(param: IAllotAccountSearch) {
        const apiUrl = "/allotAccount/page";
        return await httpRequest
            .post<IPage<IAllotAccountDetail>>(apiUrl, param);
    }

    // 分页查询账户
    async allotFind(param: IAllotAccountFields) {
        const apiUrl = "/allotAccount/find";
        return await httpRequest
            .post<IAllotAccountDetail[]>(apiUrl, param);
    }

    // 禁用账户
    async allotDisable(param: IAllotAccountFields) {
        const apiUrl = "/allotAccount/disable";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    // 启用账户
    async allotEnable(param: IAllotAccountFields) {
        const apiUrl = "/allotAccount/enable";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }



    // 充值接口
    async allotRecharge(param: IAccountRechargeFields) {
        const apiUrl = "/allotAccount/recharge";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }


    // 充值记录查询
    async allotRechargePage(param: IAccountRechargeSearch) {
        const apiUrl = "/allotAccount/recharge/page";
        return await httpRequest
            .post<IPage<IAccountRechargeDetail>>(apiUrl, param);
    }

    // 转账接口
    async allotTransfer(param: IAccountTransferFields) {
        const apiUrl = "/allotAccount/transfer";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    // 转账记录查询
    async allotTransferPage(param: IAccountTransferSearch) {
        const apiUrl = "/allotAccount/transfer/page";
        return await httpRequest
            .post<IPage<IAccountTransferDetail>>(apiUrl, param);
    }

    // 账单信息查询
    async allotBillListPage(param: any) {
        const apiUrl = "/allot/listPage";
        return await httpRequest
            .post<IPage<any>>(apiUrl, param);
    }
    // 账单信息查询
    async allotLogPage(param: any) {
        const apiUrl = "/allotAccount/log/page";
        return await httpRequest
            .post<IPage<any>>(apiUrl, param);
    }
    // 核销单查询
    async allotWriteoffPage(param: IAllotAccountWriteoffSearch) {
        const apiUrl = "/allotAccount/writeoff/page";
        return await httpRequest
            .post<IPage<IAllotAccountWriteoffDetail>>(apiUrl, param);
    }
    // 往来交易汇总查询
    async allotTransactionPage(param: IAllotAccountTransactionSearch) {
        const apiUrl = "/allot/transactions";
        return await httpRequest
            .post<IPage<IAllotAccountTransactionDetail>>(apiUrl, param);
    }
    // 核销
    async allotWriteoff(param: IAllotAccountWriteoffFields) {
        const apiUrl = "/allotAccount/writeoff/audit";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }
    //充值金额统计
    async allotRechargeTotalAmount(param: IAccountRechargeSearch) {
        const apiUrl = "/allotAccount/recharge/rechargeTotalAmount";
        return await httpRequest
            .post<number>(apiUrl, param);
    }
    //转账金额统计
    async allotTransferTotalAmount(param: IAccountTransferSearch) {
        const apiUrl = "/allotAccount/transfer/rechargeTotalAmount";
        return await httpRequest
            .post<IRechargeTotalAmount>(apiUrl, param);
    }
    //核销金额统计
    async allotwriteoffTotalAmount(param: IAllotAccountWriteoffSearch) {
        const apiUrl = "/allotAccount/writeoff/writeoffTotalAmount";
        return await httpRequest
            .post<number>(apiUrl, param);
    }
    //往来交易汇总金额统计接口
    async allotTransactionTotalAmount(param: IAllotAccountWriteoffSearch) {
        const apiUrl = "/allot/transactionsAmount";
        return await httpRequest
            .post<number>(apiUrl, param);
    }
    //欠款金额统计
    async allotSelectSummaryAmount(shopCode: string) {
        const apiUrl = `/allotAccount/selectSummary/${shopCode}`;
        return await httpRequest
            .get<IAllotSummaryAmount>(apiUrl);
    }
    //统计信息
    async allotSummaryAmount(param: any) {
        const apiUrl = `/allot/allotSummary`;
        return await httpRequest
            .post<IAllotAccountSummary>(apiUrl, param);
    }
    // 充值消息分页查询
    async rechangeMsgPage(param: IRechangeMsgSearch) {
        const apiUrl = `/account/msg/search/pg`;
        return await httpRequest
            .post<IPage<IRechangeMsgFields>>(apiUrl, param);
    }
    // 充值消息查询
    async rechageMsgFindOne(msgId: string) {
        const apiUrl = `/account/msg/select/${msgId}`;
        return await httpRequest
            .get<IRechangeMsgFields>(apiUrl);
    }
    // 重发
    async resendMsg(code: string) {
        const apiUrl = `/account/writeoff/reissueMsg/${code}`;
        return await httpRequest
            .post<IRechangeMsgFields>(apiUrl);
    }
    //系统应收查询(分页)
    async receivablePage(param: IAccountReceivableSearchParam) {
        const apiUrl = "/account/manualAccount/page";
        return await httpRequest
            .post<IPage<IAccountReceivableDetail>>(apiUrl, param);
    }
    //充值记录导出
    receivableExport(param: IAccountReceivableSearch) {
        const apiUrl = "/account/manualAccount/export";
        return httpRequest.postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }

    // 账户合并列表
    async customerMergePage(searchVo: ICustomerMergePageSearch) {
        const apiUrl = "/customerMerge/page";
        return await httpRequest
            .post<IPage<ICustomerMergeItem>>(apiUrl, searchVo);
    }

    // 账户合并关联
    async customerMergeBind(param: ICustomerMergeBindData) {
        const apiUrl = "/customerMerge/bind";
        return await httpRequest
            .post<boolean>(apiUrl, param);
    }

    // 账户合并删除
    async customerMergeDelete(id: string) {
        const apiUrl = `/customerMerge/delete/${id}`;
        return await httpRequest
            .get<boolean>(apiUrl);
    }

    // 账户合单条查询
    async customerMergeOne(id: string) {
        const apiUrl = `/customerMerge/mergeCustomerList/${id}`;
        return await httpRequest
            .get<IMergerCustermerInfo[]>(apiUrl);
    }

    // 账户合导出
    async customerMergeExport(param: ICustomerMergePageSearch) {
        const apiUrl = `customerMerge/export`;
        return await httpRequest
            .postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }
    // 关联单号查询
    async getTradeCode(code: string) {
        const apiUrl = `/account/recharge/getTradeCodes/${code}`;
        return await httpRequest
            .get<any>(apiUrl);
    }
}

export const accountService = new AccountService();
